// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8VbiD","footer_text":"Footer_footer_text__8UQc0","footer_links_container":"Footer_footer_links_container__sW3ey","footer_links":"Footer_footer_links__oSJop"};